const state = () => ({
  resetTimeout: false
});

const getters = {
  resetTimeout(state) {
    return state.resetTimeout;
  }
};

const mutations = {
  setResetTimeout(state, payload) {
    state.resetTimeout = payload;
  }
};

const actions = {
  setResetTimeout({ commit }, payload) {
    commit('setResetTimeout', payload);
  }
};

export const sendButton = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
